import { createMemoryHistory } from 'history';
const createHistory = createMemoryHistory();
export default createHistory;
